import { FC, useState, useEffect } from 'react'
import { Modal, Descriptions, Row, Card, Col, Image, Popconfirm, message, Input, Button } from 'antd'
import styles from './index.module.scss'
import { DeleteOutlined } from '@ant-design/icons'
import {
  getStandradProductRelations,
  StandradProductRelations,
  deleteStandradProductRelations,
  addStandradProductRelations,
} from '../../../services/standardProduct'
import { getErrorMessage } from '../productInfo'
import { Link } from 'react-router-dom'
interface AssociatedGoodsProps {
  onDeleteAssociatedGoods: () => void
  id: string
  onCancel: () => void
  onAddAssociatedGoods: () => void
}


const labelList = [
  {
    label: '自动关联',
    field: 'auto',
  },
  {
    label: '手动关联',
    field: 'manual',
  },
]

const AssociatedGoods: FC<AssociatedGoodsProps> = ({
  onDeleteAssociatedGoods,
  id,
  onCancel,
  onAddAssociatedGoods,
}) => {
  const [loading, setLoading] = useState(false)
  const [productList, setProductList] = useState<
    Record<'auto' | 'manual', StandradProductRelations[]>
  >({
    auto: [],
    manual: [],
  })

  const getStandradProductRelationsHandler = id => {
    getStandradProductRelations(id)
      .then(({ data }) => {
        const result = data.reduce(
          (initival, item) => {
            if (item.auto) {
              initival.auto.push(item)
            } else {
              initival.manual.push(item)
            }
            return initival
          },
          { auto: [], manual: [] } as Record<'auto' | 'manual', StandradProductRelations[]>
        )
        setProductList(result)
      })
      .catch(err => message.error(getErrorMessage(err)))
  }

  const deleteAssociatedGoodsHandler = pId => {
    deleteStandradProductRelations(id, pId)
      .then(() => {
        message.success('删除成功')
        getStandradProductRelationsHandler(id)
        onDeleteAssociatedGoods?.()
      })
      .catch(err => message.error(getErrorMessage(err)))
  }

  const onAddHandler = (productId: string) => {
    if (!productId) {
      return
    }
    setLoading(true)
    addStandradProductRelations(id, productId)
      .then(() => {
        getStandradProductRelationsHandler(id)
        onAddAssociatedGoods?.()
      })
      .catch(err => {
        if (err?.response?.status === 409) {
          return message.error(`商品 ${productId} 已被关联`)
        }
        message.error(getErrorMessage(err))
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!id) {
      setProductList({
        auto: [],
        manual: [],
      })
      return
    }
    getStandradProductRelationsHandler(id)
  }, [id])

  return (
    <Modal
      visible={!!id}
      title="标品关联商品"
      width="70%"
      onCancel={onCancel}
      destroyOnClose
      footer={
        <Button type="primary" onClick={onCancel}>
          关闭窗口
        </Button>
      }
    >
      <Descriptions column={1} layout="vertical">
        {labelList.map(label => (
          <Descriptions.Item label={label.label} key={label.field}>
            <Row gutter={24}>
              {productList[label.field].map(item => (
                <Col span={4} key={item.productId}>
                  <Card bordered className={styles.relative}>
                    <Image src={item.product?.images?.[0]?.full?.url} preview={false} />
                    <Popconfirm
                      title="确认删除？"
                      okText="确认"
                      cancelText="取消"
                      onConfirm={() => deleteAssociatedGoodsHandler(item.product?.id)}
                    >
                      <button className={styles.btn}>
                        <DeleteOutlined />
                      </button>
                    </Popconfirm>
                  </Card>
                  <Descriptions>
                    <Descriptions.Item>
                      <Link to={`/discover/${item.product?.id}`} target="_blank">
                        PID:{item.product?.id}
                      </Link>
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              ))}
            </Row>
          </Descriptions.Item>
        ))}
      </Descriptions>
      <Input.Search
        placeholder="productId"
        allowClear
        onSearch={onAddHandler}
        enterButton="Add"
        loading={loading}
      />
    </Modal>
  )
}

export default AssociatedGoods
